<!-- Fullscreen overlay hiding background while downloading and closing/redirecting -->
<div class="fixed inset-0 z-[9999] bg-white flex items-center justify-center">
  <div class="text-center">
    <div class="w-10 h-10 border-4 border-slate-200 border-t-[#307FE1] rounded-full animate-spin mx-auto mb-3"></div>
    <p class="text-sm font-medium text-slate-600">Downloading invoice...</p>
  </div>
</div>
